export default __webpack_public_path__ + "5e2755935a8ad47745044850a602c1e1.svg";